import YAML from 'yaml';
import UIPanel from './uiPanel';
import UIContainer from './uiContainer';
import UIScroller from './uiScroller';
import { getEnvVariable } from './utils/env';
export default class Model {
    static async getYaml(relativePath) {
        const publicUrl = getEnvVariable('PUBLIC_URL');
        const filePath = `${publicUrl}${relativePath}`;
        const response = await fetch(filePath);
        const text = await response.text();
        return text;
    }
    static async fromFile(relativePath) {
        const text = await Model.getYaml(relativePath);
        return new Model(text);
    }
    structure;
    error;
    uiComponents;
    datasource;
    schema;
    constructor(text, datasource = undefined) {
        this.uiComponents = [];
        try {
            const options = { prettyErrors: true };
            this.structure = YAML.parse(text, options);
            this.datasource = datasource;
            this.genUIComponents();
            this.bindDatasource();
        }
        catch (error) {
            if (error) {
                this.error = error.toString();
            }
            else {
                this.error = 'An undefined error has occured.';
            }
        }
    }
    bindDatasource() {
        if (!this.datasource) {
            return;
        }
        Object.keys(this.datasource).forEach((key) => {
            const c = this.getByDataIndex(key);
            if (c) {
                c.value = this.datasource[key];
            }
        });
    }
    isValid() {
        return this.error === undefined;
    }
    getError() {
        if (this.error !== undefined) {
            return this.error;
        }
        else {
            return '';
        }
    }
    setSchema(schema) {
        this.schema = schema;
    }
    async validate() {
        let errors = [];
        // 1) Field-level validations (existing logic)
        for (const name of Object.keys(this.schema.fields)) {
            const item = this.getByName(name);
            try {
                await this.schema.validateAt(name, { [name]: item.value });
            }
            catch (error) {
                errors.push(error);
                item.error = error.message;
            }
        }
        // 2) Object-level validations - if available (new step)
        try {
            const allValues = {};
            for (const name of Object.keys(this.schema.fields)) {
                const item = this.getByName(name);
                allValues[name] = item?.value;
            }
            // Validate the entire object
            // { abortEarly: false } ensures Yup gathers all errors in "error.inner"
            await this.schema.validate(allValues, { abortEarly: false });
        }
        catch (error) {
            // If there's an "inner" array, it may contain multiple ValidationErrors
            if (error.inner && error.inner.length > 0) {
                for (const validationError of error.inner) {
                    // Typically, object-level t]ests have no 'path', so we treat them as global errors
                    if (!validationError.path) {
                        errors.push(validationError);
                    }
                }
            }
            else {
                // Single error object (no "inner")
                if (!error.path) {
                    errors.push(error);
                }
            }
        }
        return errors;
    }
    getByDataIndex(dataIndex) {
        for (const c of this.uiComponents) {
            const result = c.getByDataIndex(dataIndex);
            if (result !== undefined) {
                return result;
            }
        }
        return undefined;
    }
    getByName(name) {
        for (const c of this.uiComponents) {
            const result = c.getByName(name);
            if (result !== undefined) {
                return result;
            }
        }
        return undefined;
    }
    getMultipleByName(...names) {
        return names.map((n) => this.getByName(n));
    }
    setAtAnchor(name, children) {
        const anchor = this.getByName(name);
        anchor.children = children;
    }
    genUIComponents() {
        for (const s of this.structure) {
            if ('panel' in s) {
                const panel = new UIPanel(s.panel);
                this.uiComponents.push(panel);
            }
            else if ('container' in s) {
                const container = new UIContainer(s.container);
                this.uiComponents.push(container);
            }
            else if ('scroller' in s) {
                const scroller = new UIScroller(s.scroller);
                this.uiComponents.push(scroller);
            }
        }
    }
    getComponents() {
        if (!this.isValid()) {
            return null;
        }
        const components = [];
        for (const c of this.uiComponents) {
            components.push(c.getComponent());
        }
        return components;
    }
}
//# sourceMappingURL=model.js.map